import { nanoid } from '@reduxjs/toolkit';
import type { Reference } from '@sydle/ui-api';

export enum EObjectStorage {
  published = 'published',
  draft = 'draft',
  history = 'history',
  none = 'none',
}

/**
 * Interface que define um objeto do Explorer.
 * @author leonardo.couto
 * @author gabriel.carmo
 */
export class EObject {
  public static CLASS_ID = '000000000000000000000087';

  // /** Identificador do objeto no Mongo. */
  _id: string;

  /** Referência para classe do objeto. */
  _class: Reference;

  /** Data de última atualização. */
  _lastUpdateDate: any;

  /** Data de criação. */
  _creationDate: any;

  /** Usuário da última atualização. */
  _lastUpdateUser: Reference;

  /** Usuário da criação. */
  _creationUser: Reference;

  /** Referencia para o objeto publicado. */
  _publishedObject: Reference;

  /** Revisão do objeto. */
  _revision: string;

  /** Revisão da classe do objeto. */
  _classRevision: string;

  /** Demais campos */
  [name: string]: any;

  constructor(data?: any) {
    Object.assign(this, data);
  }

  /**
   * Test if id is an EObjectId
   */
  public static isEObjecId(id: string): boolean {
    if (!id) return false;

    return !!id.match(/^[0-9a-fA-F]{24}$/)?.length;
  }

  public static isValid(object: EObject): boolean {
    if (!object) return false;
    if (!object._id) return false;
    if (!object._class) return false;

    return true;
  }
}

export class EObjectBuilder<Type extends EObject> {
  protected object: Partial<Type | EObject>;

  constructor(data?: Partial<EObject>) {
    this.object = {};
    Object.assign(this.object, data);
    if (!this.object._id) {
      this.id(nanoid(24));
    }
  }

  class(_class: Reference): EObjectBuilder<Type> {
    this.object._class = _class;
    return this;
  }

  id(_id: string): EObjectBuilder<Type> {
    this.object._id = _id;
    return this;
  }

  build(): Partial<Type | EObject> {
    return this.object;
  }
}
